export const config = {
  apiKey: "AIzaSyD6UNVzzveZJedV9DDo2KkClIJYKulzRUM",
  authDomain: "jobsdone-da765.firebaseapp.com",
  projectId: "jobsdone-da765",
  storageBucket: "jobsdone-da765.appspot.com",
  messagingSenderId: "624972275553",
  appId: "1:624972275553:web:e03db3a67616efcabaef20",
  measurementId: "G-5HZ71JWC78"
};